// @flow

import React from 'react';
import { useIntl } from 'react-intl';
import {
  InputV2,
  InputConsumer,
  MultiSelectInput
} from '@catalytic/catalytic-ui';
import { types } from '@catalytic/react-view';
import useFieldContext from './FieldContext';
import { useHandleBlur, useHandleChange } from './ViewHelpers';

const ToggleSwitchView = ({
  schema: getSchema,
  setValue,
  value
}: types.ToggleSwitchView) => {
  const schema = getSchema();
  const fieldContext = useFieldContext();
  const {
    className,
    contextValues,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    fieldName,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    readOnly,
    required,
    type
  } = fieldContext || {};
  const handleBlur = useHandleBlur({ onBlur, setValue, type });
  const handleChange = useHandleChange({ onChange, setValue, type });
  const intl = useIntl();
  const trueOption = [
    {
      label: intl.formatMessage({
        id: 'toggleSwitchView.true',
        defaultMessage: 'True'
      }),
      value: true
    }
  ];
  const falseOption = [
    {
      label: intl.formatMessage({
        id: 'toggleSwitchView.false',
        defaultMessage: 'False'
      }),
      value: false
    }
  ];
  const stringValue = String(value);
  let defaultValue = [];

  if (stringValue === 'true') {
    defaultValue = trueOption;
  }

  if (stringValue === 'false') {
    defaultValue = falseOption;
  }

  return (
    <InputV2
      className={className}
      contextValues={contextValues}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      fieldName={fieldName}
      hasValidation={hasValidation}
      id={id}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      schema={schema}
      title={displayName}
      type={type}
      value={value}
    >
      <InputConsumer>
        {props => (
          <MultiSelectInput
            defaultValue={defaultValue}
            embedded={embedded}
            id={id}
            isSearchable={false}
            name={name}
            options={[...trueOption, ...falseOption]}
            placeholder={intl.formatMessage({
              id: 'toggleSwitchView.placeholder',
              defaultMessage: 'Select...'
            })}
            required={required}
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
ToggleSwitchView.displayName = 'ToggleSwitchView';

export default React.memo<types.ToggleSwitchView>(ToggleSwitchView);
